import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { animationKeyframes } from '../../styles/keyframes';
import styled from '../../styles/styled';
import { Box } from '../layout';
import { AppIcon } from '../icons';
import { Theme } from '../../styles';
export const AnimatedImage = props => {
    return (_jsx(Container, { animationDuration: props.animationDuration, src: props.src, children: _jsx(ImageContainer, { src: props.src, ...{ [props.shouldMask ? 'data-clarity-mask' : 'data-clarity-unmask']: 'true' } }) }));
};
export const AnimatedStreemshotCamera = props => {
    return (_jsx(Container, { animationDuration: props.animationDuration, src: '', children: _jsx(AppIcon, { name: "StreemshotCamera" }) }));
};
const Container = styled(Box)((props) => ({
    animation: props.src
        ? `${animationKeyframes.scaleToNothing} ${props.animationDuration}ms ease`
        : `${animationKeyframes.fadeOut} ${props.animationDuration}ms ease`,
    animationFillMode: 'forwards',
    transformOrigin: 'bottom left',
    background: !props.src && Theme.colors.whiteA50,
}), {
    display: 'flex',
    height: '100%',
    position: 'absolute',
    marginLeft: 'auto',
    marginRight: 'auto',
    left: 0,
    right: 0,
    zIndex: 3,
    justifyContent: 'center',
    alignItems: 'center',
    pointerEvents: 'none',
});
const ImageContainer = styled.img({
    pointerEvents: 'none',
    objectFit: 'contain',
    height: '100%',
    maxWidth: '100%',
});
//# sourceMappingURL=animated_image.js.map